import React, { useRef, useState } from "react";
import { ArrowLeftRight } from "lucide-react";

export const BeforeAfter = ({ before, after, alt }) => {
  const [pos, setPos] = useState(50);
  const wrapRef = useRef(null);
  const drag = useRef(false);

  const onMove = (clientX) => {
    if (!wrapRef.current) return;
    const rect = wrapRef.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  return (
    <div
      ref={wrapRef}
      className="relative w-full h-full overflow-hidden select-none"
      onMouseMove={(e) => drag.current && onMove(e.clientX)}
      onMouseUp={() => (drag.current = false)}
      onMouseLeave={() => (drag.current = false)}
      onTouchMove={(e) => onMove(e.touches[0].clientX)}
    >
      <img src={after} alt={alt} className="absolute inset-0 w-full h-full object-cover"/>
      <div className="absolute inset-0" style={{ width: `${pos}%`, overflow: "hidden" }}>
        <img src={before} alt="original" className="absolute inset-0 w-full h-full object-cover" style={{ width: `${100 / (pos / 100 || 0.01)}%` }}/>
      </div>
      <span className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 font-mono-eyebrow">Before</span>
      <span className="absolute top-4 right-4 bg-black text-[#F6F5F1] px-3 py-1 font-mono-eyebrow">After</span>
      <div
        data-testid="ba-divider"
        className="absolute top-0 bottom-0 w-[2px] bg-white cursor-ew-resize"
        style={{ left: `calc(${pos}% - 1px)` }}
        onMouseDown={() => (drag.current = true)}
        onTouchStart={() => (drag.current = true)}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center">
          <ArrowLeftRight className="w-4 h-4 text-black"/>
        </div>
      </div>
      <input
        type="range" min="0" max="100" value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        data-testid="ba-slider"
        className="absolute bottom-4 left-1/2 -translate-x-1/2 w-1/2 accent-black"
      />
    </div>
  );
};
